//  This is a generated file, do not edit it directly
import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';
import { SvgChevronRight } from '../icons/ChevronRight';

export function ChevronRightIcon(
  props: Omit<SvgIconProps, 'component' | 'children'>,
): React.ReactElement {
  return (
    <SvgIcon {...props} component={SvgChevronRight} data-qa="ChevronRightIcon">
      <svg />
    </SvgIcon>
  );
}
